import React from "react"
import { Box, Heading, Text, Image } from "theme-ui"
import Quote from "../../images/quote.svg"

const QuoteBlock = ({ block }) => {
  const { body } = block

  return (
    <Box
      sx={{
        textAlign: "center",
        borderBottom: "3px solid",
        borderColor: "primary",
        pb: [3, 3, 5],
        mb: 5,
      }}
    >
      <Image
        src={Quote}
        sx={{
          mb: 4,
          textAlign: "center",
          color: "primary",
          maxWidth: ["30px", "30px", "50px"],
        }}
      />

      <Text
        sx={{
          lineHeight: ["default", "default", "1.1"],
          fontSize: [2, 3, 3, 4],
          color: "primary",
          my: 0,
          p: {
            my: 0,
            mt: [2, 2, 5],
            mb: 3,
          },
          strong: {
            fontSize: 2,
            mt: [5, 5, 3, 3],
            display: "block",
            lineHeight: ["default", "0", "0"],
          },
          em: {
            lineHeight: ["default", "0", "0"],
            fontSize: 2,
            fontStyle: "normal",
          },
        }}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </Box>
  )
}

export default QuoteBlock
